[
  {
    "id": 1,
    "label": "Phase 1: Identify Your Challenges",
    "subheader": "Get your lab optimization score in just 9 questions."
  },
  {
    "id": 2,
    "label": "Phase 2: Assess Your Readiness",
    "subheader": "Get your lab optimization score in just 9 questions."
  },
  {
    "id": 3,
    "label": "Phase 3: Define Your Priorities",
    "subheader": "Get your lab optimization score in just 9 questions."
  },
  {
    "id": 4,
    "label": "Access Your Score Now",
    "subheader": "Your score is ready!"
  },
  {
    "id": 5,
    "label": "Your Lab Optimization Score",
    "subheader": "The results are in, check your score below."
  }
]